import axios from 'axios';
import Vue from 'vue'

export default {
    getCustomers () {
        return axios.get('/api/customers/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    loadCustomer (selectedCustomer) {
        return axios.get('/api/customers/load',  { params: { id: selectedCustomer } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getActiveCustomers () {
        return axios.get('/api/customers/active/list')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getDirectories(page,pageSize,customerId,cityId) {
        return axios.get('/api/customers/directory/list', { params: {customerId: customerId, cityId: cityId,page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllCustomers (filter, statusFilter, TrialStatus, paymentStatus ,page, pageSize) {
        return axios.get('/api/customers/custmerslist', { params: {  filter: filter, statusFilter: statusFilter ,paymentStatus:paymentStatus ,TrialStatus:TrialStatus, page: page, pageSize: pageSize} })
        .then(customersListDTO => {
            if (customersListDTO && customersListDTO.data) return customersListDTO.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveCustomer(customer){
        return axios.post("/api/customers/save",customer)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Clinet enregistré avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCountCustomers(){
        return axios.get('/api/customers/count/customers')
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    updatePayment(customerId, paymentStatus) {
        return axios.get('/api/customers/payment/'+customerId+'/'+paymentStatus)
        .then(response => {
            if (response && (response.data))   return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportCsv(){
        axios({
            url:'/api/customers/export/csv',
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'officines.csv');
            document.body.appendChild(link);
            link.click();
          });
    },

}

